// Local foundation only: no globals, storage, script loading or provider connection.
const schemas = {
  page_view: { page_key: ['landing', 'register', 'login', 'pricing', 'product'] },
  registration_cta_click: { placement: ['header', 'hero', 'other'] },
  registration_start: {},
  sign_up: { role: ['retailer', 'owner', 'broker'] },
  email_verified: { role: ['retailer', 'owner', 'broker'] },
  registration_error: { category: ['validation', 'network', 'server', 'unknown'] },
};
const languages = ['nl', 'en', 'de', 'fr', 'es', 'it'];

export function createConversionMeasurement({ send, environment = 'test' } = {}) {
  let enabled = false;
  let consent = false;
  let generation = 0;
  let pending = 0;

  const invalidate = () => { generation += 1; };
  return {
    setEnabled(value) {
      enabled = value === true;
      invalidate();
    },
    setConsent(value) {
      consent = value === 'granted';
      invalidate();
    },
    // true means accepted for deferred delivery, never proof of provider receipt.
    track(name, parameters = {}, language = 'nl') {
      try {
        if (!enabled || !consent || typeof send !== 'function' || pending >= 20) return false;
        if (!Object.prototype.hasOwnProperty.call(schemas, name)) return false;
        if (!parameters || typeof parameters !== 'object') return false;
        const schema = schemas[name];
        const payload = {
          event_version: 1,
          environment: environment === 'production' ? 'production' : 'test',
          language: languages.includes(language) ? language : 'unknown',
        };
        for (const key of Object.keys(schema)) {
          if (!schema[key].includes(parameters[key])) return false;
          payload[key] = parameters[key];
        }
        const acceptedGeneration = generation;
        pending += 1;
        Promise.resolve().then(() => {
          pending -= 1;
          if (!enabled || !consent || generation !== acceptedGeneration) return;
          // The eventual adapter must itself remain lightweight/nonblocking.
          return send(name, payload);
        }).catch(() => {}); // Measurement failure must not escape into business code.
        return true;
      } catch (_) {
        return false;
      }
    },
  };
}
